import styled from 'styled-components';
import { Select } from '@landlord-tech/ui-kit-opp';

export const SSelect = styled(Select)`
  &&& {
  }
`;
